var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-row items-center border-l-4 card-bg px-4 py-5 gap-6 rounded-md transform transition-all duration-200",class:{
    'border-level-h': _vm.item.type.level == 'H',
    'border-level-m': _vm.item.type.level == 'M',
    'border-level-l': _vm.item.type.level == 'L',
    '-translate-x-4': _vm.is_selected,
    'shadow-lg': _vm.is_selected,
    'shadow-none': !_vm.is_selected,
  },on:{"click":function($event){return _vm.$emit('on_select')}}},[_c('h3',{staticClass:"font-medium text-2xl text-dark flex-1"},[_vm._v(_vm._s(_vm.item.type.title))]),_c('button',{staticClass:"self-end text-2xl font-semibold mr-10",class:{
      'pointer-events-none': _vm.item.count == 0,
      'text-dark': _vm.item.count == 0,
      'text-primary': _vm.item.count > 0,
    },on:{"click":function($event){return _vm.$emit('show_websites')}}},[_vm._v(" "+_vm._s(_vm._f("num_suffix")(_vm.item.count,1))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }